import { useState } from 'react';
import Helmet from 'react-helmet';
import { Global, css } from '@emotion/react';
import Header from '../home/Header';
import MobileNav from '../home/MobileNav';
import Footer from '../home/Footer';
import Hero from '../home/Hero';
import LogoBar from '../home/LogoBar';
import PlayerSection from '../home/PlayerSection';
import PublisherContentSection from '../home/PublisherContentSection';
import ContextualEngineSection from '../home/ContextualEngineSection';
import CaseStudiesSection from '../home/CaseStudiesSection';
import CtaSection from '../home/CtaSection';
import { colors } from '../home/theme';

const globalStyles = css`
  body {
    background: ${colors.coreBlue};
    margin: 0;
  }

  html {
    scroll-behavior: smooth;
  }
`;

const SITE_URL = 'https://www.pixels.ai';
const PAGE_URL = `${SITE_URL}/`;
// 1600x900 brand card using the current pixel-mark logo on the current core-blue background.
const OG_IMAGE = `${SITE_URL}/og-pixels-1600x900.png`;
const TITLE = 'Pixels | Contextual Video Stream for Publisher Supply';
const DESCRIPTION =
  'AI-powered contextual video for publisher supply: frame-by-frame video analysis matched to the most relevant web, app and CTV placements in real time.';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Pixels',
  url: PAGE_URL,
  logo: `${SITE_URL}/logo/pixels-logo-full-ondark.png`,
  description: DESCRIPTION,
};

export default function Home() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      <Global styles={globalStyles} />
      <Helmet title={TITLE}>
        <link rel="canonical" href={PAGE_URL} />
        <meta name="description" content={DESCRIPTION} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Pixels" />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:url" content={PAGE_URL} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:image:width" content="1600" />
        <meta property="og:image:height" content="900" />
        <meta property="og:image:alt" content="Pixels" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content={OG_IMAGE} />
        <meta name="twitter:image:alt" content="Pixels" />

        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>
      <Header onMenuClick={() => setMobileNavOpen(true)} />
      <MobileNav open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      <Hero />
      <LogoBar />
      <PlayerSection />
      <PublisherContentSection />
      <ContextualEngineSection />
      <CaseStudiesSection />
      <CtaSection />
      <Footer />
    </>
  );
}
